import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopService } from '../../../configuration/services/shop.service';
import { LabeledProductService } from '../../../labeledproducts/services/labeledproduct.service';
import { InventoryLabeledProductService } from '../../services/inventory-labeledproduct.service';
import { LabeledProductShopStockService } from '../../../labeledproducts/services/labeledproductshopstock.service';
import { ProductCategoryService } from '../../../common/services/productcategory.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { resolve } from 'url';


@Component({
  selector: 'app-wizard-inventory',
  templateUrl: './wizard-inventory.component.html',
  styleUrls: ['./wizard-inventory.component.css'],
  providers:[ShopService,LabeledProductService, InventoryLabeledProductService,LabeledProductShopStockService,ProductCategoryService]
})

export class WizardInventoryComponent implements OnInit {

  shops:any = [];
  labeledProduct:any = {};
  photos:any = [];
  private sub: any;
  inventoryId: number = null;
  new_stock:any = 1;
  new_shop_id:any = null;
  labeledProductShopsStock:any = [];
  barcode = null;

  constructor(private route: ActivatedRoute, private labeledProductService:LabeledProductService, private router: Router,private shopService:ShopService,public toastr: ToastsManager,vcr: ViewContainerRef,
    private inventoryLabeledProductService:InventoryLabeledProductService, private labeledProductShopStockService:LabeledProductShopStockService, private productCategoryService:ProductCategoryService ) {
      this.toastr.setRootViewContainerRef(vcr); 
     }

  ngOnInit() {
    this.getShops();
    this.sub = this.route.params.subscribe(params => {
      this.route.queryParams.subscribe(queryParams => {
          if (params['id'] !== undefined){
              this.inventoryId = params['id'];
          }
      });
    });
    this.new_shop_id = parseInt(localStorage.getItem('shop'));
    document.getElementById("barcode-input").focus();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }



  getShops(){
    return new Promise((resolve, reject) => {
        this.shopService.query({})
        .subscribe((shops) => {
            this.shops = shops;
            resolve();
        });
    });
  }

  getSubfamily(labeledProduct){
    var params = {
        where:{
            labeledproduct_id:labeledProduct.id
        }
    }
    this.productCategoryService.query(params).subscribe((subfamilies) =>{
      if (subfamilies.length == 0){
        this.toastr.error('', 'Aparta este producto para añadirle categoría antes de incluirlo en el inventario', {dismiss: "controlled",showCloseButton:true});
      }
    });
}

  getLabeledProducts(barcode){
    if (barcode.length == 13){
      if (this.labeledProduct.id){
        this.addNewStock().then(()=>{
          this.getLabeledProduct(barcode);
        });
      }else{
        this.getLabeledProduct(barcode);
      }
      
    }
  }

  getLabeledProduct(barcode){
    var params = {
        where: {barcode:{contains:barcode}},
        sort: 'id DESC',
        limit: 1
    };
    this.labeledProductService.query(params)
        .subscribe((labeledProducts) => {
          if (labeledProducts.length > 0 && barcode != ""){
            this.barcode = null
            this.labeledProduct = labeledProducts[0];
            this.getProductPhotos(this.labeledProduct);
            this.getStockByShop(this.labeledProduct.id);
            this.getSubfamily(this.labeledProduct);
          }else{
            this.labeledProduct = {
              barcode:barcode
            };
            this.labeledProductShopsStock = []
          }
    });
  }

  deleteProductSelected(){
        this.labeledProduct = {};
        this.photos = [];
        this.labeledProductShopsStock = [];
        this.barcode = null;
        this.new_stock = 1;
        document.getElementById("barcode-input").focus();
  }

  getProductPhotos(labeledProduct){
    this.labeledProductService.getProductPhotos(labeledProduct.id)
    .subscribe((result) => {
        this.photos = result;
    })
  }

  createInventoryStock(resolve){
    let body = {
      expected_stock: this.new_stock,
      shop: this.new_shop_id,
      labeledproduct:  this.labeledProduct.id,
      inventory: this.inventoryId
    }
    this.inventoryLabeledProductService.create(body).subscribe((result) => {      
        this.labeledProduct = {};
        this.photos = [];
        this.labeledProductShopsStock = [];
        this.barcode = null;
        this.new_stock = 1;
        document.getElementById("barcode-input").focus();
        resolve()
    })
  }

  updateInventoryStock(inventoryLabeled,resolve){
    let body = {
      expected_stock: parseInt(inventoryLabeled.expected_stock) + parseInt(this.new_stock),
      id: inventoryLabeled.id
    }
    this.inventoryLabeledProductService.update(body).subscribe((result) => {
        this.labeledProduct = {};
        this.photos = [];
        this.labeledProductShopsStock = [];
        this.barcode = null;
        this.new_stock = 1;
        document.getElementById("barcode-input").focus();
        resolve()
    })
  }

  createOrUpdateStockByshop(){
    return new Promise((resolve, reject) => {
      let currentElementStock = this.labeledProductShopsStock.filter((e)=> {return e.shop.id === this.new_shop_id && e.labeledproduct.id === this.labeledProduct.id})
      let currentStock = currentElementStock[0] && currentElementStock[0].expected_stock != null? currentElementStock[0].expected_stock:0
      var stock = currentStock + parseInt(this.new_stock);
      if (currentElementStock[0]){
          this.labeledProductShopStockService.update({id:currentElementStock[0].id, expected_stock:stock}).subscribe(() =>{
            resolve();
          });
      }else{
          this.labeledProductShopStockService.create({stock:0, labeledproduct: this.labeledProduct.id,shop: this.new_shop_id}).subscribe(() =>{
            resolve();
          });
      }
    });
  }

  addNewStock(){
    return new Promise((resolve, reject) => {
      this.createOrUpdateStockByshop().then(()=>{
        console.log(1)
        this.getInventoryLabeledStock().then((inventoryLabeled:any)=>{
          if (inventoryLabeled.length > 0){
            this.updateInventoryStock(inventoryLabeled[0],resolve);
          }else{
            this.createInventoryStock(resolve);
          }
        });
      });
    });
  }

  getInventoryLabeledStock(){
    return new Promise((resolve, reject) => {
      let params = {
        labeledproduct: this.labeledProduct.id,
        inventory: this.inventoryId,
        shop: this.new_shop_id
      }
      this.inventoryLabeledProductService.query(params).subscribe((result) => {
        resolve(result);
      });
    });
  }

  getStockByShop(id){
    let params = {
        labeledproduct: id
    }
    this.labeledProductShopStockService.query(params).subscribe((labeledProductShopStock) => {
        this.labeledProductShopsStock = labeledProductShopStock;
    });
}
  
}



// WEBPACK FOOTER //
// ./src/app/inventory/components/wizard-inventory/wizard-inventory.component.ts